import React, { useEffect, useState, useContext } from 'react';
import {
    Table, Button, Modal, ModalBody, ModalHeader, ModalFooter, Input,
    Pagination, PaginationItem, PaginationLink} from 'reactstrap';
import { Link } from 'react-router-dom';
import { AppContext } from '../AppContext';
import withRoleAccess from '../components/withRoleAccess';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ReactPaginate from 'react-paginate';

import './UserManagement.css';

const TITLE = 'Reportes de Retroalimentación Estudiantil';
const APIURL = process.env.REACT_APP_API_URL;

const MySwal = withReactContent(Swal)

const UserManagement = () => {

    document.title = TITLE + " - Administrar usuarios";

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({
        nombres: '',
        apellidos: '',
        username: '',
        numeroidentificacion: '',
        idRole: 0,
        idUnidad: 0,
        idPrograma: 0, 
    });
    const [searchResults, setSearchResults] = useState([]);
    const [roles, setRoles] = useState([]);
    const [rolesLoading, setRolesLoading] = useState(true);

    const [refreshTable, setRefreshTable] = useState(false);
    const [roleNameSelected, setRoleNameSelected] = useState('');
    const [unidadOptions, setUnidadOptions] = useState([]);
    const [programasOptions, setProgramasOptions] = useState([]);
    const [isCreateButtonDisabled, setIsCreateButtonDisabled] = useState(true);

    const [currentPage, setCurrentPage] = useState(0);
    const usersPerPage = 10;

    const currentUser = useContext(AppContext).currentUser;

    useEffect(() => {
        if (currentUser && currentUser !== undefined && currentUser.usuario !== "") {
            MySwal.showLoading();
            fetch(`${APIURL}/api/Account/get-roles`)
                .then((response) => response.json())
                .then((data) => {
                    setRoles(data);
                    setRolesLoading(false);
                    if (searchCriteria.idRole === 0 && data.length > 0) {
                        const adminRole = data.find(item => item.tipo === 1);
                        if (adminRole !== undefined) {
                            setSearchCriteria({ ...searchCriteria, idRole: adminRole.idhedrole, idUnidad: 0, idPrograma: 0 });
                            setRoleNameSelected(adminRole.rolename);
                        } else {
                            setSearchCriteria({ ...searchCriteria, idRole: data[0].idhedrole, idUnidad: 0, idPrograma: 0 });
                            setRoleNameSelected(data[0].rolename);
                        }
                    }
                    MySwal.close();
                })
                .catch((error) => {
                    console.error('Error fetching roles:', error);
                });
            setIsCreateButtonDisabled(isCreateUserButtonDisabled());
        }
    }, [currentUser]);

    useEffect(() => {
        if (currentUser && currentUser !== undefined && currentUser.usuario !== "" && searchCriteria.idRole !== 0) {
            setIsCreateButtonDisabled(isCreateUserButtonDisabled())
            fetchUsers();
        }
    }, [searchCriteria.idRole, searchCriteria.idUnidad, searchCriteria.idPrograma, refreshTable]);

    const fetchUsers = () => {
        let url = `${APIURL}/api/Account/active-users?idRole=${searchCriteria.idRole}`;

        if (roleNameSelected == "Asistente POSTGRADO" && searchCriteria.idPrograma != 0) {
            url += `&idPrograma=${searchCriteria.idPrograma}`;
        }

        if (roleNameSelected == "Asistente GRADO" && searchCriteria.idPrograma != 0) {
            url += `&idPrograma=${searchCriteria.idPrograma}`;
        }

        fetch(url)
            .then((response) => response.json())
            .then((data) => {
                setUsers(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching users:', error);
            });
    };

   
    const handleDeleteRole = (idheduser) => {

        const payload = {
            idHedUser: idheduser,
            idRole: searchCriteria.idRole,
            idPrograma: searchCriteria.idPrograma
        };

        MySwal.fire({
            title: 'Eliminando usuario...',
            allowOutsideClick: false,
            didOpen: () => {
                MySwal.showLoading();
            }
        });
        fetch(`${APIURL}/api/Account/delete-user-role`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                MySwal.close();
                if (response.status === 200) {
                    setModalIsOpen(false);
                    setSearchCriteria({
                        ...searchCriteria,
                        nombres: '',
                        apellidos: '',
                        username: '',
                        numeroidentificacion: '',
                    });
                    setRefreshTable(!refreshTable);
                } else {
                    console.error('Error al eliminar el rol al usuario.');
                }
            })
                .catch((error) => {
                    console.error('Error al eliminar el rol al usuario:', error);
            });
    };

    const isCreateUserButtonDisabled = () => {
        if (roleNameSelected === "Administrador") {
            return false;
        } else if (roleNameSelected === "Asistente GRADO" && searchCriteria.idUnidad === 0) {
            return true;
        } else if (roleNameSelected === "Asistente POSTGRADO" && (searchCriteria.idUnidad === 0 || searchCriteria.idPrograma === 0)) {
            return true;
        }
        return false;
    };

    const renderAdditionalInput = () => {
        return (
            <>
                {roleNameSelected === 'Asistente POSTGRADO' || roleNameSelected === 'Asistente GRADO' ? (
                    <div className="d-flex" style={{ gap: '1rem' }}>
                        <Input
                            type="select"
                            name="idUnidad"
                            value={searchCriteria.idUnidad}
                            onChange={handleSearchCriteriaChange}
                        >
                            {unidadOptions.map((unidad) => (
                                <option key={unidad.idunidad} value={unidad.idunidad}>
                                    {unidad.nombreunidad}
                                </option>
                            ))}
                        </Input>
                        {(roleNameSelected === 'Asistente POSTGRADO' || roleNameSelected === 'Asistente GRADO') && (
                            <Input
                                type="select"
                                name="idPrograma"
                                value={searchCriteria.idPrograma}
                                onChange={handleSearchCriteriaChange}
                            >
                                {programasOptions.map((programa) => (
                                    <option key={programa.idprograma} value={programa.idprograma}>
                                        {programa.idprograma + " - " + programa.nombre}
                                    </option>
                                ))}
                            </Input>
                        )}
                    </div>
                ) : null}
            </>
        );
    };


    const renderTable = () => {
        return (
            <div>
                <div className="d-flex flex-column" style={{ gap: '1rem' }}>
                    <Input
                        type="select"
                        name="idRole"
                        value={searchCriteria.idRole}
                        onChange={handleSearchCriteriaChange}
                    >
                        {rolesLoading ? (
                            <option value="">Cargando roles...</option>
                        ) : (
                            roles.map((role) => (
                                <option key={role.idhedrole} value={role.idhedrole}>
                                    {role.rolename}
                                </option>
                            ))
                        )}
                    </Input>
                    {renderAdditionalInput()}
                </div>
                <div className="d-flex justify-content-end pt-3 pb-3">
                    <Button color="success" onClick={toggleModal} disabled={isCreateButtonDisabled}>
                        Agregar usuario
                    </Button>
                </div>
                <Table responsive={true} striped={true}>
                    <thead>
                        <tr>
                            <th className="text-center col-1" scope="col">
                                Nombres
                            </th>
                            <th className="text-center col-1" scope="col">
                                Usuario
                            </th>
                            <th className="text-center col-1" scope="col">
                                Correo
                            </th>
                            <th className="col-1" scope="col">
                                {' '}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr key={user.idheduser}>
                                <td className="text-center">
                                    {user.nombres + ' ' + user.apellidos}
                                </td>
                                <td className="text-center">{user.username}</td>
                                <td className="text-center">{user.email}</td>
                                <td>
                                    <div className="d-flex gap-1" style={{ gap: '0.5rem' }}>
                                        <span id={'delete_btn_' + index}>
                                            <Link
                                                className="btn btn-danger"
                                                to="#"
                                                onClick={() => handleDeleteRole(user.idheduser)}
                                            >
                                                Eliminar
                                            </Link>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    const handleModalClosed = () => {
        setSearchCriteria({
            ...searchCriteria,
            nombres: '',
            apellidos: '',
            username: '',
            numeroidentificacion: '',
        });
        setSearchResults([]);
    };

    const toggleModal = () => {
        setModalIsOpen(!modalIsOpen);
    };

    const handleSearchCriteriaChange = (e) => {

        const { name, value } = e.target;

        if (name === 'idRole') {
            const selectedRole = roles.find((role) => role.idhedrole === parseInt(value));
            const roleName = selectedRole ? selectedRole.rolename : '';
            setRoleNameSelected(roleName);

            if (roleName === 'Asistente GRADO') {
                //Fetch unidades
                fetch(`${APIURL}/api/Account/get-unidades`)
                    .then((response) => response.json())
                    .then((data) => {
                        setUnidadOptions(data);
                        if (data.length > 0) {
                            fetch(`${APIURL}/api/Account/get-carreras?idUnidad=${data[0].idunidad}`)
                                .then((response) => response.json())
                                .then((dataProg) => {
                                    setProgramasOptions(dataProg);
                                    if (dataProg.length > 0) {
                                        setSearchCriteria({ ...searchCriteria, idRole: value, idUnidad: data[0].idunidad, idPrograma: dataProg[0].idprograma });
                                    } else {
                                        setSearchCriteria({ ...searchCriteria, idRole: value, idUnidad: data[0].idunidad, idPrograma: 0 });
                                    }
                                })
                        } else {
                            setSearchCriteria({
                                ...searchCriteria,
                                idRole: value,
                                idUnidad: 0,
                                idPrograma: 0
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching unidades:', error);
                    });
            } else if (roleName === 'Asistente POSTGRADO') {
                //Fetch unidades
                fetch(`${APIURL}/api/Account/get-unidades`)
                   .then((response) => response.json())
                   .then((data) => {
                        setUnidadOptions(data);
                        if (data.length > 0) {
                            fetch(`${APIURL}/api/Account/get-programas?idUnidad=${data[0].idunidad}`)
                                .then((response) => response.json())
                                .then((dataProg) => {
                                    setProgramasOptions(dataProg);
                                    if (dataProg.length > 0) {
                                        setSearchCriteria({ ...searchCriteria, idRole: value, idUnidad: data[0].idunidad, idPrograma: dataProg[0].idprograma });
                                    } else {
                                        setSearchCriteria({ ...searchCriteria, idRole: value, idUnidad: data[0].idunidad, idPrograma: 0 });
                                    }
                                })
                        } else {
                            setSearchCriteria({
                                ...searchCriteria,
                                idRole: value,
                                idUnidad: 0,
                                idPrograma: 0
                            });
                        }
                   })
                   .catch((error) => {
                        console.error('Error fetching unidades:', error);
                   });
            } else {
                setSearchCriteria({
                    ...searchCriteria,
                    idRole: value,
                    idUnidad: 0,
                    idPrograma: 0,
                });
                setUnidadOptions([]); //Limpiar unidades
                setProgramasOptions([]); //Limpiar programas
            }
        } else if (name === 'idUnidad') {
            
            if (roleNameSelected === 'Asistente POSTGRADO') {
                //Fetch programas
                fetch(`${APIURL}/api/Account/get-programas?idUnidad=${value}`)
                    .then((response) => response.json())
                    .then((data) => {
                        setProgramasOptions(data);
                        if (data.length > 0) {
                            setSearchCriteria({
                                ...searchCriteria,
                                [name]: value,
                                idPrograma : data[0].idprograma
                            });
                        } else {
                            setSearchCriteria({
                                ...searchCriteria,
                                [name]: value,
                                idPrograma: 0
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching programas:', error);
                    });
            } else if (roleNameSelected === 'Asistente GRADO') {
                fetch(`${APIURL}/api/Account/get-carreras?idUnidad=${value}`)
                    .then((response) => response.json())
                    .then((data) => {
                        setProgramasOptions(data);
                        if (data.length > 0) {
                            setSearchCriteria({
                                ...searchCriteria,
                                [name]: value,
                                idPrograma: data[0].idprograma
                            });
                        } else {
                            setSearchCriteria({
                                ...searchCriteria,
                                [name]: value,
                                idPrograma: 0
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error fetching programas:', error);
                    });
            } else {
                setSearchCriteria({
                    ...searchCriteria,
                    [name]: value,
                    idPrograma: 0
                });
            }

        } else if (name === 'idPrograma') {
            setSearchCriteria({
                ...searchCriteria,
                idPrograma: value,
            });
        } else {
            setSearchCriteria({ ...searchCriteria, [name]: value });
        }

    };

    const handleSearch = () => {
        const payload = {
            nombres: searchCriteria.nombres,
            apellidos: searchCriteria.apellidos,
            numeroidentificacion: searchCriteria.numeroidentificacion,
            username: searchCriteria.username,
            idRole: searchCriteria.idRole,
            idPrograma: searchCriteria.idPrograma !== 0 ? searchCriteria.idPrograma : searchCriteria.idUnidad
        };

        MySwal.fire({
            title: 'Buscando usuarios...',
            text: 'Espere un momento',
            allowOutsideClick: false,
            didOpen: () => {
                MySwal.showLoading();
            }
        });
        fetch(`${APIURL}/api/Account/posibles-usuarios`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                setSearchResults(data);
                setCurrentPage(0);
                MySwal.close();
            })
            .catch((error) => {
                console.error('Error al conseguir usuarios potenciales:', error);
            });
    };

    const handleSelectUser = (idpersona) => {

        const payload = {
            idpersona: idpersona,
            idRole: searchCriteria.idRole,
            idPrograma: searchCriteria.idPrograma !== 0 ? searchCriteria.idPrograma : searchCriteria.idUnidad
        };

        MySwal.fire({
            title: 'Agregando usuario...',
            allowOutsideClick: false,
            didOpen: () => {
                MySwal.showLoading();
            }
        });
        fetch(`${APIURL}/api/Account/create-user`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => {
                MySwal.close();
                if (response.status === 200) {
                    setModalIsOpen(false);
                    setSearchCriteria({
                        ...searchCriteria,
                        nombres: '',
                        apellidos: '',
                        username: '',
                        numeroidentificacion: '',
                    });
                    setSearchResults([]);
                    setRefreshTable(!refreshTable);
                }
            })
            .catch((error) => {
                console.error('Error selecting user:', error);
            });
    };

    const contents = loading ? <p>Loading...</p> : renderTable();

    const indexOfLastUser = (currentPage + 1) * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const paginatedUsers = searchResults.slice(indexOfFirstUser, indexOfLastUser);

    const handlePageClick = (data) => {
        const selectedPage = data.selected;
        setCurrentPage(selectedPage);
    };

    return (
        <div>
            <h1>Administrar usuarios</h1>
            {contents}
            <Modal isOpen={modalIsOpen} toggle={toggleModal} centered onClosed={handleModalClosed} style={{ maxWidth: '80%', width: '80%' }}>
                <ModalHeader>Buscar usuarios</ModalHeader>
                <ModalBody>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className="mb-3">
                            <label htmlFor="nombres">Nombres</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nombres"
                                name="nombres"
                                value={searchCriteria.nombres}
                                onChange={handleSearchCriteriaChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="apellidos">Apellidos</label>
                            <input
                                type="text"
                                className="form-control"
                                id="apellidos"
                                name="apellidos"
                                value={searchCriteria.apellidos}
                                onChange={handleSearchCriteriaChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="username">Usuario ESPOL</label>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                name="username"
                                value={searchCriteria.username}
                                onChange={handleSearchCriteriaChange}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="numeroidentificacion">Cédula</label>
                            <input
                                type="text"
                                className="form-control"
                                id="numeroidentificacion"
                                name="numeroidentificacion"
                                value={searchCriteria.numeroidentificacion}
                                onChange={handleSearchCriteriaChange}
                            />
                        </div>
                    </div>
                    <div className="d-flex pb-3">
                        <Button color="primary" onClick={handleSearch}>
                            Buscar
                        </Button>
                    </div>
                    <Table responsive={true} striped={true}>
                        <thead>
                            <tr>
                                <th className="text-center col-1" scope="col">Nombres</th>
                                <th className="text-center col-1" scope="col">Apellidos</th>
                                <th className="text-center col-1" scope="col">Correo</th>
                                <th className="text-center col-1" scope="col">Identificación</th>
                                <th className="col-1" scope="col">{' '}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedUsers.map((user, index) => (
                                <tr key={index}>
                                    <td className="text-center">{user.nombres}</td>
                                    <td className="text-center">{user.apellidos}</td>
                                    <td className="text-center">{user.emailAddress}</td>
                                    <td className="text-center">{user.numeroidentificacion}</td>
                                    <td>
                                        <Link
                                            className="btn btn-success"
                                            to="#"
                                            onClick={() => handleSelectUser(user.idpersona)}
                                        >
                                            Agregar
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    {searchResults.length > 10 && (
                        <ReactPaginate
                            previousLabel={"← Anterior"}
                            nextLabel={"Siguiente →"}
                            pageCount={Math.ceil(searchResults.length / usersPerPage)}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                            previousLinkClassName={"pagination__link"}
                            nextLinkClassName={"pagination__link"}
                            disabledClassName={"pagination__link--disabled"}
                            activeClassName={"pagination__link--active"}
                        />
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggleModal}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default withRoleAccess(UserManagement, ['ADMIN']);